module.exports = __webpack_public_path__ + "img/dp15.dac8d7aa.jpeg";